import React from 'react'
import { Button, Tooltip } from '@mui/material'
import FileUploadIcon from '@mui/icons-material/FileUpload'

export interface ImportButtonProps {
  onClick: () => void
  title: string
  disabled?: boolean
}

const ImportButton: React.FC<ImportButtonProps> = ({
  onClick,
  title,
  disabled = false,
}) => (
  <Tooltip title={title}>
    <Button variant="contained" size="medium" startIcon={<FileUploadIcon />} onClick={onClick} disabled={disabled} aria-label={title}>
      {title}
    </Button>
  </Tooltip>
)

export default ImportButton
